<template>
  <Loader
    :value="promises.fetchOne"
    :message="`${this.$t('loading', { resource: this.$t('dashboard').toLowerCase() })}...`"
    class="dashboard"
  >
    <div class="container view">
      <HeaderComponent :title="$metaInfo.title" :breadcrumb="breadcrumb">
        <template #right>
          <Actions placement="dashboard" />
          <UserSelect
            v-if="item.name && $store.getters.hasAccess('admin')"
            :value="{ id, name: item.name, avatar: item.avatar }"
            @input="setUser"
            search
            :items="fetchUsers"
            :title="$t('selectx', { x: $tc('user', 1).toLowerCase() })"
          />
        </template>
      </HeaderComponent>
      <div class="dashboard__content">
        <Tasks data-field="tasks" :value="item.tasks" :show-create="false" />
        <Deadlines data-field="deadlines" :value="item.deadlines" />
        <Card :title="$t('recentActivity')" class="recent-activity-widget">
          <template #default>
            <LastActivity data-field="last-activity" :value="item.lastActivity" />
          </template>
        </Card>
      </div>
    </div>
  </Loader>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import UserApi from '@/api/User'

import HeaderComponent from '@/components/Header'
import Deadlines from '@/components/Deadlines/Widget'
import LastActivity from '@/components/LastActivity/Widget'
import Card from '@/components/Card'
import Tasks from '@/components/Task/Widget'
import UserSelect from '@/components/User/Select/Modal'
import Actions from '@/components/Actions'

export default {
  props: {
    id: {
      type: String,
      default() {
        return this.$store.state.user.id
      },
    },
  },
  watch: {
    id: {
      handler: 'fetch',
      immediate: true,
    },
  },
  metaInfo() {
    return {
      title: this.$t('dashboard'),
    }
  },
  computed: {
    ...mapState('Dashboard', ['item', 'promises']),
    ...mapState(['businessSite', 'user']),
    isOwn() {
      return this.item.id === this.$store.state.user.id
    },
    breadcrumb() {
      return [{ title: this.item.name }]
    },
  },
  methods: {
    ...mapActions('Dashboard', {
      fetch(dispatch) {
        if (!this.id) return
        return dispatch('fetch', { id: this.id })
      },
    }),
    fetchUsers(filter) {
      return UserApi.get({ filter: { ...filter, type: 'user' } }, { query: 'UserSearch' })
    },
    setUser(item) {
      if (item.id === this.$store.state.user.id) return this.$router.push({ name: 'dashboard' })
      else return this.$router.push({ name: 'dashboard-user', params: { id: item.id } })
    },
  },
  created() {
    this.$bus.$on('task:update', this.fetch)
    this.$bus.$on('task:remove', this.fetch)
  },
  beforeDestroy() {
    this.$bus.$off('task:update', this.fetch)
    this.$bus.$off('task:remove', this.fetch)
  },
  components: {
    Card,
    HeaderComponent,
    Deadlines,
    LastActivity,
    Tasks,
    UserSelect,
    Actions,
  },
}
</script>

<style lang="scss">
.dashboard {
  background-color: $background-grey;

  &__content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
    grid-template-rows: repeat(2, minmax(450px, 38vh));
    grid-gap: 2rem 2rem;

    @include respond-below('phone') {
      grid-template-columns: 1fr;
    }

    & > * {
      animation: fadeIn 300ms ease;
    }
  }

  .user-select-modal {
    .select-modal__input {
      background: transparent !important ;
      .user-card {
        padding: 0.5rem 1.25rem 0.5rem 0.75rem;
        border-radius: var(--border-radius);
        border: 1px solid var(--border-color);
      }
    }
  }

  [data-field='tasks'] {
    grid-row-end: span 2;
  }
}
</style>
